module.exports = __webpack_public_path__ + "img/button_kuemmern.e4508397.png";